import { render, staticRenderFns } from "./user-activity-details.html?vue&type=template&id=08143ba1&scoped=true&external"
import script from "./user-activity-details.js?vue&type=script&lang=js&external"
export * from "./user-activity-details.js?vue&type=script&lang=js&external"
import style0 from "./user-activity-details.scss?vue&type=style&index=0&id=08143ba1&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08143ba1",
  null
  
)

export default component.exports